import { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const PageMading = lazy(() => import('./views/mading'));

const Mading = () => {
  return (
    <Routes>
      <Route path="/" element={<PageMading />} />
    </Routes>
  );
};

export default Mading;
